import React from 'react';
import ContactForm from './../contactForm/ContactForm';
import styles from './ContactPage.module.css';

const ContactPage = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Ready to Transform Your Business?</h1>
      <p className={styles.subHeader}>
        Whether you're seeking a game-changing solution, expert advice, or just want to explore possibilities, we’re here to help. Fill out the form below, and let’s start building something amazing together!
      </p>
      <ContactForm />
    </div>
  );
};

export default ContactPage;
